import type { BoardViewDto } from '../types';

export const mockBoardViews: BoardViewDto[] = [
  {
    id: 'bv-1',
    boardId: 'board-1',
    name: 'Lista',
    type: 1,
    createdById: 'user-1',
    createdAt: '2024-01-10T10:00:00Z',
    config: null,
  },
  {
    id: 'bv-2',
    boardId: 'board-1',
    name: 'Kanban',
    type: 2,
    createdById: 'user-1',
    createdAt: '2024-01-10T10:01:00Z',
    config: null,
  },
  {
    id: 'bv-4',
    boardId: 'board-1',
    name: 'Gantt',
    type: 4,
    createdById: 'user-1',
    createdAt: '2024-01-10T10:02:00Z',
    config: null,
  },
  {
    id: 'bv-3',
    boardId: 'board-2',
    name: 'Lista',
    type: 1,
    createdById: 'user-1',
    createdAt: '2024-01-11T09:00:00Z',
    config: null,
  },
];
